import { createFileRoute } from "@tanstack/react-router";
import ThankYouSaintEs from "@/pages/es/ThankYouSaintEs";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

const ES_URL = `${SITE_URL}/es/thank-you-saint-google`;

export const Route = createFileRoute("/es/thank-you-saint-google")({
  head: () => ({
    meta: [
      { name: "robots", content: "noindex, follow" },
      {
        title:
          "Gracias — Reserve su consulta gratuita de SAINT® | Neuro Wellness",
      },
      {
        name: "description",
        content:
          "Gracias por verificar su elegibilidad para SAINT®. Próximo paso: reserve su consulta gratuita o llámenos al (954) 827-9793 in Coral Springs, FL.",
      },
      {
        property: "og:title",
        content: "Reserve su consulta gratuita de SAINT®",
      },
      {
        property: "og:description",
        content:
          "Próximo paso: reserve su consulta gratuita de SAINT® con Neuro Wellness TMS Centers of America.",
      },
      { property: "og:url", content: ES_URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { name: "twitter:card", content: "summary_large_image" },
      {
        name: "twitter:title",
        content: "Reserve su consulta gratuita de SAINT®",
      },
      {
        name: "twitter:description",
        content:
          "Próximo paso: reserve su consulta gratuita de SAINT® con Neuro Wellness TMS Centers of America.",
      },
    ],
    links: [
      { rel: "canonical", href: ES_URL },
      ...buildHreflang("/thank-you-saint-google"),
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <ThankYouSaintEs google />;
}
